import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Logger } from '@app/core/logger.service';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
import { IonLoaderService } from '@app/shared/services/ion-loader/ion-loader.service';
import { SearchService } from '@app/shared/services/search/search.service';
import { ModalController, ToastController } from '@ionic/angular';
const log = new Logger('SpecilatySelectComponent');

@Component({
  selector: 'app-specilaty-select',
  templateUrl: './specilaty-select.component.html',
  styleUrls: ['./specilaty-select.component.scss'],
})
export class SpecilatySelectComponent implements OnInit {
  public specialties: any[] = [];
  public arrayFiltered: any[] = [];
  public isLoading: boolean = false;
  public dataForm: FormGroup;
  public value: any[] = [];
  selectionLimit = 5;
  others = [
    "NKEueD6vai3R78Eo63QC", // Medico en formación
    "ZDIVBabMX5mJJM2jXl1m" // Otros profesionales de la Salud
  ];
  isDisabled: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private loader: IonLoaderService,
    private searchService: SearchService,
    private formBuilder: FormBuilder,
    private fireService: FirebaseService,
    private toastCtrl: ToastController
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.inializeApp();
  }

  private initForm() {
    this.dataForm = this.formBuilder.group({
      specialties: this.formBuilder.array([], Validators.required)
    });
  }

  select() {
    this.modalCtrl.dismiss(this.dataForm.get('specialties').value, 'data');
  }

  other() {
    this.modalCtrl.dismiss({ id: 'profesional-de-la-salud', name: 'Otro' }, 'data');
  }

  async inializeApp() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      await this.initSpecialties();
      if (this.value) {
        this.dataForm.get('specialties').patchValue(this.value);
        this.isDisabled = this.value.some(item => this.others.includes(item.id));
        for (const item of this.value) {
          this.selectedItems.push(this.formBuilder.control(item));
        }
      }
    } catch (error) {
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  closeModal() {
    this.modalCtrl.dismiss({}, 'close');
  }

  async initSpecialties(): Promise<void> {
    try {
      const resp = await this.fireService.afs.collection('specialties').ref.where('status', '==', 'active').where('showInRegister', '==', true).orderBy('nameStr', 'asc').get();
      this.specialties = resp.docs.map(e => {
        return {
          id: e.id,
          name: e.get('name'),
        };
      });
      this.specialties = this.specialties
        .filter(item => !this.others.includes(item.id))
        .concat(
          this.specialties
            .filter(item => this.others.includes(item.id))
            .map(item => ({ ...item, selection: 'single' }))
        );

      this.arrayFiltered = [...this.specialties];

    } catch (error) {
      log.error(error);
    }
  }

  search(event: any) {
    if (event && event.detail && event.detail.value && String(event.detail.value).length >= 3) {
      const searchStr: string = this.searchService.clearSearch(String(event.detail.value), true);
      this.arrayFiltered = this.specialties.filter((item) => {
        const name: string = this.searchService.clearSearch(String(item && item.name ? item.name : ''), true)
        return (name.includes(searchStr));
      })
    }
  }

  public ionCancel() {
    this.arrayFiltered = [...this.specialties];
  }

  public ionClear() {
    this.arrayFiltered = [...this.specialties];
  }

  isChecked(item: any): boolean {
    return this.selectedItems.controls.some(x => x.value.id === item.id);
  }

  get selectedItems(): FormArray {
    return this.dataForm.get('specialties') as FormArray;
  }

  clear() {
    this.selectedItems.clear();
    this.isDisabled = false;
  }

  onCheckboxChange(event: any, item: any) {
    if (event.detail.checked) {
      if (item && item.selection && item.selection == 'single') {
        this.clear();
      }
      if (this.selectedItems.length < this.selectionLimit) {
        this.selectedItems.push(this.formBuilder.control(item));
      } else {
        (event.target as HTMLIonCheckboxElement).checked = false;
        this.toast('Limite de especialidades a seleccionar alcanzado');
      }
    } else {
      const index = this.selectedItems.controls.findIndex((x) => x.value.id === item.id);
      if (index !== -1) {
        this.selectedItems.removeAt(index);
      }
    }
    const singleIndex = this.selectedItems.controls.findIndex((x) => x.value.selection === 'single');
    if (item && item.selection && item.selection == 'single' && singleIndex > -1) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  public async toast(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: 1800,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }
}
